import React from "react";
import T from "prop-types";
import { get } from "lodash";
import NoteTooltip from "./NoteTooltip";
import { shortDate, shortDateYYandTime } from "../../../../lib/formatters/date";

export default function AuditedNoteTooltip({
  field,
  obj,
  includeTime = false,
  notePrefix = "",
  placement = "right"
}) {
  if ([undefined, null].includes(obj[field]) || !obj[`${field}_audit`]) {
    return null;
  }

  const timeFunc = includeTime ? shortDateYYandTime : shortDate;

  let approvalText = `${notePrefix}Updated by ${get(
    obj,
    `${field}_audit.updated_by.full_name`
  )} on ${timeFunc(get(obj, `${field}_audit.updated_at`))}`;

  const reason = get(obj, `${field}_audit.reason`);

  if (reason) {
    approvalText += ` | ${reason}`;
  }

  return (
    <NoteTooltip
      color="rgba(255, 255, 255, 0.25)"
      note={approvalText}
      placement={placement}
      icon="fa-info-circle"
    />
  );
}

AuditedNoteTooltip.propTypes = {
  field: T.string.isRequired,
  obj: T.shape({}),
  placement: T.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/NoteTooltip/AuditedNoteTooltip.jsx